import { render } from "./ResourceSelect.vue?vue&type=template&id=64665994"
import script from "./ResourceSelect.vue?vue&type=script&lang=js"
export * from "./ResourceSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__